module.exports = __webpack_public_path__ + "static/media/Logo.09c32eb5.png";